import { useQuery } from '@tanstack/react-query'
import { getChannelPlayers } from '../../services'
import { GetChannelPlayersRequest } from '../../../type'
import { DashboardKeys } from '@/modules/dashboard/keys'

export const useQueryGetChannelPlayers = (
	channelId: string,
	params?: GetChannelPlayersRequest,
) => {
	return useQuery({
		queryKey: [DashboardKeys.ChannelPlayers, channelId, params],
		queryFn: () => getChannelPlayers(channelId, params),
		enabled: !!channelId,
	})
}

export default useQueryGetChannelPlayers
